"use server";

import {
  getSignInUrl,
  getSignUpUrl,
  signOut,
} from "@workos-inc/authkit-nextjs";

export async function getSignIn() {
  return await getSignInUrl();
}

export async function getSignUp() {
  return await getSignUpUrl();
}

export async function handleSignOut() {
  return await signOut({
    returnTo: "/",
  });
}
